import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlashSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "var(--main-color)",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.111 23a.998.998 0 0 1-.99-1.11l.77-7.09h-5.89a1 1 0 0 1-.83-1.56l7.89-11.8a1 1 0 0 1 1.17-.38 1 1 0 0 1 .65 1l-.77 7.14h5.89a1 1 0 0 1 .83 1.56l-7.89 11.8a1 1 0 0 1-.83.44Z" })
});
export { SvgFlashSolid as ReactComponent };
